const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentVideo extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}

		this.imageElement = this.querySelector('.component-video__image');
		this.iframeElement = this.querySelector('.component-video__video iframe');
		this.videoElement = this.querySelector('.component-video__video video');

		if (this.imageElement) {
			this.imageElement.addEventListener('click', () => {
				if (this.iframeElement) {
					this.loadIframeSrc(true);
				}
				else if (this.videoElement) {
					this.videoElement.play();
				}
				this.hideCoverImage();
			});
		}
		else {
			this.loadIframeSrc();
		}

		if (this.videoElement) {
			this.videoElement.setAttribute('controlslist', 'nodownload noplaybackrate');
			this.videoElement.setAttribute('disablepictureinpicture', 'true');
			this.videoElement.setAttribute('disableremoteplayback', 'true');
			this.videoElement.setAttribute('playsinline', 'true');
		}

		this.initialized = true;

	}

	loadIframeSrc(autoplay = false) {
		if (this.iframeElement) {
			let dataSrc = this.iframeElement.getAttribute('data-src');
			if (autoplay) {
				dataSrc = dataSrc + '&autoplay=1';
			}
			this.iframeElement.setAttribute('src', dataSrc);
		}
	}

	hideCoverImage() {
		if (this.imageElement) {
			this.imageElement.classList.add('hide');
		}
	}

}

customElements.define('component-video', ComponentVideo, {extends: 'div'});